export default function cmApiUrl(url) {
  const whitelistUrls = ['car-and-driver-test-np.awsacsnp.autotrader.com', 'www-stage.caranddriver.com', 'www.caranddriver.com', 'hearstapps.net'];

  // client side requests have cm-api prefixed to the url to support Car and Driver brand
  if (typeof window !== 'undefined' && whitelistUrls.some(value => window?.location?.hostname.includes(value))) {
    if (url.startsWith('/')) {
      return `/cm-api${url}`;
    }
    return `cm-api/${url}`;
  }
  return url;
}